import { AppState, lessonTap, lessonConfirmCta, lessonAdvance, closeLesson } from '@/store/gameStore';
import { getLesson } from './lessons';
import { renderTile } from './tiles';
import { topbar } from './lobby';

/** **굵게** 표기를 안전하게 strong 노드로 변환(우리 상수 문자열 전용). */
function richText(parent: HTMLElement, text: string): void {
  const parts = text.split('**');
  parts.forEach((part, i) => {
    if (i % 2 === 1) {
      const s = document.createElement('strong');
      s.textContent = part;
      parent.appendChild(s);
    } else if (part) {
      parent.appendChild(document.createTextNode(part));
    }
  });
}

export function renderLesson(state: AppState): HTMLElement {
  const root = document.createElement('div');
  root.appendChild(topbar(state));

  const lesson = getLesson(state.activeLesson!);
  if (!lesson) {
    closeLesson();
    return root;
  }
  const beat = lesson.beats[state.lessonBeat];
  const isLast = state.lessonBeat >= lesson.beats.length - 1;

  const screen = document.createElement('div');
  screen.className = 'screen lesson';
  root.appendChild(screen);

  // 헤더
  const head = document.createElement('div');
  head.className = 'lesson__head';
  const close = document.createElement('button');
  close.className = 'btn btn--ghost';
  close.textContent = '← 닫기';
  close.onclick = closeLesson;
  head.appendChild(close);
  const prog = document.createElement('div');
  prog.className = 'lesson__prog';
  prog.textContent = `${lesson.title} · ${state.lessonBeat + 1}/${lesson.beats.length}`;
  head.appendChild(prog);
  screen.appendChild(head);

  const stage = document.createElement('div');
  stage.className = 'lesson__stage';
  screen.appendChild(stage);

  // 맥락 손패(조작 불가)
  if (beat.show) {
    const showRow = document.createElement('div');
    showRow.className = 'lesson__show';
    for (const t of beat.show) showRow.appendChild(renderTile(t, { size: 'sm' }));
    stage.appendChild(showRow);
  }

  // 튜터 안내
  const tutor = document.createElement('div');
  tutor.className = 'tutor lesson__tutor';
  const title = document.createElement('div');
  title.className = 'tutor__title';
  title.textContent = '튜터';
  tutor.appendChild(title);
  const body = document.createElement('div');
  richText(body, beat.instruct);
  tutor.appendChild(body);
  stage.appendChild(tutor);

  // 조작 영역
  if (beat.pool && beat.targets) {
    const correctCount = beat.pool.filter((t) => beat.targets!.includes(t)).length;
    const pool = document.createElement('div');
    pool.className = 'lesson__pool';
    beat.pool.forEach((t, i) => {
      const el = renderTile(t, { size: 'lg', onClick: () => lessonTap(i) });
      if (state.lessonTapped.includes(i)) el.classList.add('tile--correct');
      pool.appendChild(el);
    });
    stage.appendChild(pool);

    const counter = document.createElement('div');
    counter.className = 'lesson__counter';
    counter.textContent = `찾음 ${state.lessonTapped.length} / ${correctCount}`;
    stage.appendChild(counter);
  } else if (beat.cta && !state.lessonDone) {
    const cta = document.createElement('button');
    cta.className = 'btn ' + (beat.ctaStyle === 'primary' ? 'btn--primary' : beat.ctaStyle === 'gold' ? 'btn--gold' : '');
    cta.style.fontSize = '17px';
    cta.textContent = beat.cta;
    cta.onclick = lessonConfirmCta;
    stage.appendChild(cta);
  }

  // 통과 후: 칭찬 + 다음
  if (state.lessonDone) {
    if (beat.note) {
      const note = document.createElement('div');
      note.className = 'lesson__note';
      richText(note, beat.note);
      stage.appendChild(note);
    }
    const next = document.createElement('button');
    next.className = 'btn btn--primary';
    next.textContent = isLast ? '완료' : '다음';
    next.onclick = lessonAdvance;
    stage.appendChild(next);
  }

  // 전체 화면 연출
  if (state.flash) {
    const flash = document.createElement('div');
    flash.className = 'riichi-flash';
    const span = document.createElement('span');
    span.textContent = state.flash;
    flash.appendChild(span);
    root.appendChild(flash);
  }

  return root;
}
